var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.096 15.8243L9.353 10.056C8.80169 10.4909 8.20423 10.8127 7.56064 11.0214C6.91704 11.2308 6.29431 11.3355 5.69245 11.3355C4.10432 11.3355 2.75855 10.7878 1.65513 9.69245C0.55171 8.59785 0 7.26452 0 5.69245C0 4.12118 0.55171 2.77942 1.65513 1.66717C2.75855 0.555723 4.0959 0 5.66717 0C7.25529 0 8.59705 0.55171 9.69245 1.65513C10.787 2.75855 11.3343 4.10432 11.3343 5.69245C11.3343 6.34487 11.226 6.99288 11.0093 7.63647C10.7919 8.28007 10.4741 8.84422 10.056 9.32892L15.8483 15.1213C15.9486 15.2224 15.9904 15.3396 15.9735 15.4728C15.9575 15.6068 15.9077 15.7239 15.8243 15.8243C15.6902 15.9414 15.5647 16 15.4475 16C15.3303 16 15.2132 15.9414 15.096 15.8243ZM5.69245 10.3063C6.97964 10.3063 8.07062 9.85936 8.96539 8.96539C9.85936 8.07062 10.3064 6.97964 10.3064 5.69245C10.3064 4.37155 9.86338 3.26412 8.97743 2.37015C8.09148 1.47537 6.98806 1.02799 5.66717 1.02799C4.36313 1.02799 3.26372 1.47537 2.36894 2.37015C1.47497 3.26412 1.02799 4.37155 1.02799 5.69245C1.02799 6.99649 1.47497 8.09148 2.36894 8.97743C3.26372 9.86338 4.37155 10.3063 5.69245 10.3063Z",
    fill: "#686B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0fd50b4bfe5cba82d9814c1433244cf8.svg";
export { ForwardRef as ReactComponent };